/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { User } from "./User";
import { Pagination } from "../../commons/types/Pagination";
export const ListUsersResponse = core.serialization.object({
    data: core.serialization.list(User),
    pagination: Pagination.optional(),
});
